import { LanguageConst } from '../../../utils/resources/languageconst';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface AlertCSSStyle extends UIComponentCSSStyle{
    getInnerWrapperCSSStyle():object;
    getCloseButtonDivCSSStyle():object;
    getAlertImageDivCSSStyle():object;
    getAlertMessageDivCSSStyle():object;
    getButtonDivCSSStyle():object;
    getMobileAlertImageDivCSSStyle():object;
    getMobileAlertMessageDivCSSStyle():object;
    getMobileWrapperCSSStyle():object;
    getMobileCloseButtonDivCSSStyle():object;

}
export class AlertCSSStyleImpl extends UIComponentCSSStyleImpl implements AlertCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'440px',
            display:'flex', 
            height:'617px',
            borderRadius:'8px', 
            backgroundColor:'#429984'
        };
    }


    getInnerWrapperCSSStyle():object
    {
        return{
            width:'100%', height:'100%',justifyContent:'center'
        };
    }
    getCloseButtonDivCSSStyle():object
    {
        return{

            width:'100%',
            marginTop:'17px', 
            height:'20px',
            paddingRight:'20px',
            // marginLeft:'430px',
            textAlign:"right",
            cursor:'pointer'
        };
    }

    getAlertImageDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'102px', 
            height:'150px',
            // marginLeft:'144.5px',
            marginBottom:'50px',
            textAlign:'center'
        };
    }

    getAlertMessageDivCSSStyle():object
    {
        return{
            width:'auto',
            margin:'0px 30px 132px 30px',
            textAlign:'center', 
            height:'60px',
            fontFamily:this.getResources().getFontFamily(), 
            fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '25px' : '22px',
            fontWeight:900,
            color:'#FFFFFF',
            lineHeight:'30px',
            letterSpacing:'0'
        };
    }
  
    getMobileCloseButtonDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'17px', 
            height:'20px',
            paddingRight:'20px',
            // marginLeft:'430px',
            textAlign:"right",
            cursor:'pointer'

        };
    }

    getMobileWrapperCSSStyle():object
    {
        return{
            width:'auto',
            display:'flex', 
            height:'440px',
            borderRadius:'8px', 
            backgroundColor:'#429984'
        };
    }
    getMobileAlertImageDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'50px', 
            height:'70px',
            // marginLeft:'120px',
            marginBottom:'50px',
            textAlign:'center'
        };
    }

    getMobileAlertMessageDivCSSStyle():object
    {
        return{
            width:'auto',
            margin:'0px 43px 90px 43px',
            textAlign:'center', 
            height:'60px',
            fontFamily:this.getResources().getFontFamily(), 
            fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '22px' : '14px',
            fontWeight:900,
            color:'#FFFFFF',
            lineHeight:'30px',
            letterSpacing:'0'
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
            margin:'0px 140px 40px 140px',
            color:'#429984',
        
        };
    }
   getAuthenticateButtonDivCSSStyle():object{
        return{
            color:'#429984',
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/alertcss.tsx